<template>
    <div class="charges">
        <div class="content-layout" v-if="!$store.state.loadingDmr">
            <div class="column column__small">
                <div class="block">
                    <div class="title">
                        Afgiftsdetaljer
                    </div>
                    <div class="body" v-if="$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0">
                        <line-data
                            :title="charge.AfgiftType"
                            :value="charge.Pris" v-for="charge in $store.state.carData.dmr.Afgift.AfgiftDetaljer"
                            v-bind:key="charge.DaekkerFra"
                            :wide="true"
                        />
                        <hr>
                        <line-data title="Hyppighed" :value="$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed" />
                    </div>
                    <div class="body" v-else>
                        Ingen afgiftsdetaljer
                    </div>
                </div>
            </div>
            <div class="column column__large">
                <div class="block charges-block">
                    <div class="title">
                        Opkrævede afgifter
                    </div>
                    <div class="body table">
                        <table v-if="$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length > 0">
                            <thead>
                                <tr>
                                    <th width="20%">Reg.nr.</th>
                                    <th width="35%">Type</th>
                                    <th width="30%">Dækker fra - til</th>
                                    <th width="15%">Pris</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(charge, index) in sortedCharges"
                                    v-bind:key="index"
                                >
                                    <td><div class="lp">{{ charge.RegNr }}</div></td>
                                    <td>{{ charge.AfgiftType }}</td>
                                    <td>{{ charge.DaekkerFra }} - {{ charge.DaekkerTil }}</td>
                                    <td>{{ charge.Pris }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-else>
                            Der er endnu ikke opkrævet afgifter på dette køretøj.
                        </div>
                    </div>
                </div>
                <div class="block charges-block-mobile">
                    <div class="title">
                        Opkrævede afgifter
                    </div>
                    <div class="body table">
                        <div v-if="$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length > 0">
                            <div class="single-charge" v-for="(charge, index) in sortedCharges" v-bind:key="index">
                                <line-data title="Reg.Nr." :value="charge.RegNr" />
                                <line-data title="Type" :value="charge.AfgiftType" />
                                <line-data title="Periode" :value="charge.DaekkerFra + ' - ' + charge.DaekkerTil" />
                                <line-data title="Pris" :value="charge.Pris" />
                                <hr v-if="index !== sortedCharges.length - 1">
                            </div>
                            <!--<div class="single-charge" v-for="(charge, index) in sortedCharges" v-bind:key="index">
                                Reg.Nr.: <b>{{ charge.RegNr }}</b>
                                <br>
                                Type: <b>{{ charge.AfgiftType }}</b>
                                <br>
                                Periode: <b>{{ charge.DaekkerFra }} - {{ charge.DaekkerTil }}</b>
                                <br>
                                Pris: <b>{{ charge.Pris }}</b>
                                <hr v-if="index !== sortedCharges.length - 1">
                            </div>-->
                        </div>
                        <div v-else>
                            Der er endnu ikke opkrævet afgifter på dette køretøj.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../styles/vars";

.charges {

    .block .body.table {
        @media screen and (max-width: $small) {
            overflow-x: auto !important;
        }
    }

    .charges-block-mobile {
        display: none;
    }

    @media screen and (max-width: $small) {
        .charges-block-mobile {
            display: block;
        }

        .charges-block {
            display: none;
        }
    }

    table {
        width: 100%;

        td {
            padding-top: 15px;

            .lp {
                background: url('/static/licenseplate4.png') center center no-repeat;
                background-size: cover;
                width: 95px;
                height: 25px;
                padding-top: 2px;
                padding-left: 15px;
                font-weight: 900;
                font-family: 'Arial';
                padding-right: 4px;
                text-align: center;
            }
        }
    }
}

</style>

<script>
export default {
    computed: {
        sortedCharges () {
            if (this.$store.state.carData.dmr !== null && this.$store.state.match) {
                this.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.forEach((charge) => {
                    if (charge.RegNr.includes(' ')) {

                    } else {
                        let splittedString = charge.RegNr.split('')
                        splittedString.splice(4, 0, ' ')
                        splittedString.splice(2, 0, ' ')
                        splittedString = splittedString.join('')
                        charge.RegNr = splittedString.toUpperCase()
                    }
                })
                return this.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// charges.vue?880029b2